<label class="switch">
  <input *ngIf="!changeNotificationChecked" type="checkbox" checked (click)="emitToggleValue()" />
  <input *ngIf="changeNotificationChecked" type="checkbox" (click)="emitToggleValue()" />
  <span class="slider round"></span>
</label>
